/* istanbul ignore file -- @preserve */
import { useMutation } from '@apollo/client';
import updateGlobalContactMutation from './updateGlobalContactMutation.graphql';

const useUpdateGlobalContactMutation = (options = {}) => {
  return useMutation<any, any>(updateGlobalContactMutation, {
    refetchQueries: [
      'ManagedPlatformAccountContacts',
      'DepotContacts',
      'ActivityLogs',
    ],
    ...options,
  });
};

export default useUpdateGlobalContactMutation;
